module.exports = __webpack_public_path__ + "img/9-01.4fb38f59.png";